module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-gray-on-white-d32450dea2301fe4f923ff810d5e7f07.svg";